import $$ from 'cmn-utils'

const baseUrl = "/api/device/product/";
export default {
    action: {
        get: (params) => {
            return $$.get(baseUrl + 'action/get', params)
        },
        list: (params) => {
            return $$.get(baseUrl + 'action/list', params)
        },
    },
    event: {
        list: (params) => {
            return $$.get(baseUrl + 'event/list', params)
        },
    },
    group: {
        action: {
            list: (params) => {
                return $$.get(baseUrl + 'group/action/list', params)
            },
        },
        event: {
            list: (params) => {
                return $$.get(baseUrl + 'group/event/list', params)
            },
        },
        prop: {
            list: (params) => {
                return $$.get(baseUrl + 'group/prop/list', params)
            },
        },
    },
    part: {
        list: (params) => {
            return $$.get(baseUrl + 'part/list', params)
        },
    }
}